export const Directions = Object.freeze({
    TO_APPOINTMENT: 'to',
    FROM_APPOINTMENT: 'from',
    BOTH_WAYS: 'both-ways'
})

export const RequisitionStates = Object.freeze({
    OPEN: 'open',
    CONFIRMED: 'confirmed',
})

export const TreatmentSiteRegions = Object.freeze([
    {id: 'north', name: 'Helse Nord'},
    {id: 'south', name: 'Helse Sør'},
    {id: 'middle', name: 'Helse Midt'},
    {id: 'east', name: 'Helse Øst'},
    {id: 'west', name: 'Helse Vest'},
])
